import { render, staticRenderFns } from "./EpBannerItemInsurance.vue?vue&type=template&id=53353ea6&"
import script from "./EpBannerItemInsurance.vue?vue&type=script&lang=js&"
export * from "./EpBannerItemInsurance.vue?vue&type=script&lang=js&"
import style0 from "./EpBannerItemInsurance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports